module.exports = __webpack_public_path__ + "static/img/10.e17a6e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/global/10.png
// module id = gDFl
// module chunks = 1